import { gql } from '__generated__'

/**
 * Reports a repeat visit with new marketing tags (last touch) for the current
 * user or guest session. BE-311 contract; see api/auth/privy.schema.graphql.
 */
export const TOUCH_ATTRIBUTION = gql(`
  mutation touchAttribution($data: JSON!) {
    touchAttribution(data: $data)
  }
`)
